import StringHelper from "../helpers/StringHelper";


export default function OnlyNumber(event) {
    const keyCode = event.keyCode || event.which;
    let keyValue = String.fromCharCode(keyCode);
    keyValue = StringHelper.getEnglishNum(keyValue)
    if (!(new RegExp("[0-9]").test(keyValue)))
        event.preventDefault();
    return;
}
